import React from 'react';
import { RouteContext } from '../../../../context';
import { BaseDescription } from '../../../CustomizationForm/BaseDescription';
import {
  EditModulePageQueryParams,
  useEditingModule,
} from './useEditingModule';
import { ModuleTypes } from './moduleManagementTypes';
import { getCustomModuleCard } from '../AddModule/customModuleCards';
import { LinkButton } from '../../../Buttons';
import {
  EXTENSION_SETUP_LINK,
  ModuleManagementListKeys,
  MODULE_MANAGEMENT_LIST,
} from '../../../../constants';

const SetupModulePageDescription = () => {
  const { query } = React.useContext(RouteContext);
  const {
    moduleId,
    moduleType,
    preset = '',
  } = query as EditModulePageQueryParams;
  const currentEditingModule = useEditingModule();
  const customModuleCard = getCustomModuleCard(preset);
  const [descriptionData, setDescriptionData] = React.useState<any>(null);

  React.useEffect(() => {
    // add extension flow
    if (moduleId === 'new') {
      setDescriptionData({
        title: `Add ${
          customModuleCard ? customModuleCard.name : 'a custom App'
        }`,
        description: (
          <LinkButton
            openExternally
            toPath={
              customModuleCard
                ? getCustomModuleCard(customModuleCard.name)?.learnMoreLink
                : EXTENSION_SETUP_LINK
            }
            text={
              customModuleCard
                ? `Read set up instructions for ${customModuleCard.name}`
                : 'Learn more about setting up an App'
            }
            fontType="13Medium"
          />
        ),
      });
      return;
    }

    // edit module page
    if (currentEditingModule) {
      if (moduleType === ModuleTypes.Core) {
        // when core module is disabled, it should say Enable {moduleName}
        setDescriptionData({
          title: `${currentEditingModule.disabled ? 'Enable' : 'Edit'} ${
            currentEditingModule.label
          }`,
          description: (
            <LinkButton
              openExternally
              toPath={
                MODULE_MANAGEMENT_LIST[
                  currentEditingModule.id as ModuleManagementListKeys
                ]?.learnMoreLink
              }
              text={`Learn more about configuring the ${currentEditingModule.label}
              module`}
            />
          ),
        });
        return;
      }

      setDescriptionData({
        title: `Edit ${currentEditingModule.label}`,
        description: (
          <LinkButton
            openExternally
            toPath={EXTENSION_SETUP_LINK}
            text="Learn more about setting up an extensions"
          />
        ),
      });
    }
  }, [moduleId, currentEditingModule, customModuleCard, moduleType]);

  return (
    <BaseDescription
      titleFontType="24Medium"
      title={descriptionData?.title}
      descriptions={[descriptionData?.description]}
    />
  );
};

export default SetupModulePageDescription;
